export function centsToDollars(cents: number) {
    return (cents / 100).toLocaleString("en-US", { style: "currency", currency: "USD" });
}

export function toCents(amount: Number) {
    const str = amount.toString()
    const [int] = str.split('.')
    return Number(amount.toFixed(2).replace('.', '').padEnd(int.length === 1 ? 3 : 4, '0'))
}